import {List, Set} from 'immutable';
import {IStation} from '../../api/api.types';

export interface IStationSelectorService {
  getStoredStations(key: string,
                    availableStations: List<IStation>): Set<IStation>;
  storeStations(key: string, stationList: Set<IStation>): void;
}

export class StationSelectorService implements IStationSelectorService {
  static $inject = ['$window', '$log'];

  private static STORAGE_KEY_PREFIX = 'imomo.stationStorage';

  constructor(private $window: ng.IWindowService,
              private $log: ng.ILogService) {
  }

  getStoredStations(key: string, availableStations: List<IStation>) {
    let storedObject: any;
    try {
      storedObject = this.$window.localStorage
          .getItem(`${StationSelectorService.STORAGE_KEY_PREFIX}.${key}`);
    } catch (error) {
      this.$log.error('Local storage is not available.', error);
    }
    if (!storedObject) {
      return Set<IStation>();
    }
    try {
      const parsedObject = JSON.parse(storedObject);
      if (parsedObject instanceof Array) {
        const stationIds = Set(parsedObject);
        return availableStations.filter(station => {
          return stationIds.contains(station.id);
        }).toSet();
      } else {
        this.clearStoredList(key);
        return Set<IStation>();
      }
    } catch (error) {
      this.$log.error(`Stored object in key ${key} is not valid.`, error);
      this.clearStoredList(key);
      return Set<IStation>();
    }
  }

  storeStations(key: string, stationList: Set<IStation>) {
    try {
      this.$window.localStorage
          .setItem(`${StationSelectorService.STORAGE_KEY_PREFIX}.${key}`,
              JSON.stringify(
                  stationList.map(station => station.id).toArray()));
    } catch (error) {
      this.$log.error('Could not store station list.');
    }
  }

  clearStoredList(key: string) {
    try {
      this.$window.localStorage
          .removeItem(`${StationSelectorService.STORAGE_KEY_PREFIX}.${key}`)
    } catch (error) {
      this.$log.error('Could not clear stored object.', error)
    }
  }
}
export default StationSelectorService;




/** WEBPACK FOOTER **
 ** ./app/station/selector/selector.service.ts
 **/